/***
 *
 *   LANDING HERO
 *   Headline, primary actions and the product screenshot frame.
 *
 **********/

import { Link, useTheme } from 'components/lib';
import { useTranslate } from 'app/translations';
import { rootPath } from 'utilities/routes.js';
import Shared from './landing.tailwind.js';
import Style from './hero.tailwind.js';

/* Tickets kanban, captured at 2x. width/height are the intrinsic pixels of the
   light file — they only set the aspect ratio the browser reserves before the
   image lands, so the 5px the dark file differs by does not matter. Both are
   declared at the same ratio on purpose: a theme toggle must not shift layout. */
const SHOT = {
    light: '/assets/screenshots/valetify-tickets_light.png',
    dark: '/assets/screenshots/valetify-tickets_dark.png',
    width: 1863,
    height: 983,
};

export function LandingHero(props) {
    const { _t } = useTranslate();
    const { isDark } = useTheme();

    return (
        <section id="top" className={Style.hero}>
            <div className={Style.glow} aria-hidden="true" />

            <div className={Style.inner}>
                <div className={Shared.eyebrow}>{_t('landing.hero.eyebrow')}</div>
                <h1 className={Style.title}>{_t('landing.hero.title')}</h1>
                <p className={Style.lede}>{_t('landing.hero.lede')}</p>

                <div className={Style.actions}>
                    <Link
                        url={rootPath('/signup')}
                        color="white"
                        text={_t('landing.hero.primary')}
                        className={Shared.ctaPrimary}
                    />
                    <Link
                        url={rootPath('/signin')}
                        color="primary"
                        text={_t('signin.label')}
                        className={Shared.ctaSecondary}
                    />
                </div>

                <div className={Style.frame}>
                    <div className={Style.chrome}>
                        <span className={`${Style.dot} bg-error`} />
                        <span className={`${Style.dot} bg-warning`} />
                        <span className={`${Style.dot} bg-success`} />
                    </div>

                    {/* Variant picked from the resolved theme rather than a
                        dark:hidden pair, so only one file is ever fetched.
                        ThemeProvider seeds its state synchronously, so the
                        first render already has the right one. */}
                    <img
                        src={isDark ? SHOT.dark : SHOT.light}
                        alt={_t('landing.hero.shot.alt')}
                        width={SHOT.width}
                        height={SHOT.height}
                        className={Style.screen}
                    />
                </div>
            </div>
        </section>
    );
}
